import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-rounded-2xl tw-border tw-border-white/40 tw-bg-white/50 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-900/5 tw-p-4 sm:tw-p-5" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-end sm:tw-justify-between" }
const _hoisted_3 = { class: "tw-min-w-0" }
const _hoisted_4 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-2" }
const _hoisted_5 = { class: "tw-text-2xl sm:tw-text-3xl tw-font-semibold tw-tracking-tight tw-text-slate-800" }
const _hoisted_6 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-700"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-700"
}
const _hoisted_8 = {
  key: 2,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-px-3 tw-py-1 tw-text-sm tw-font-medium tw-text-slate-700"
}
const _hoisted_9 = { class: "tw-mt-2 tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_10 = { class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600" }
const _hoisted_11 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
}
const _hoisted_12 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
}
const _hoisted_13 = {
  key: 2,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
}
const _hoisted_14 = {
  key: 3,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-white/50 tw-bg-white/40 tw-backdrop-blur tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-600"
}
const _hoisted_15 = { class: "tw-text-sm tw-text-slate-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, "Order # " + _toDisplayString(_ctx.order.id), 1),
          (!_ctx.order.isExport && _ctx.order.billOfLading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " BL# " + _toDisplayString(_ctx.order.billOfLading.billOfLadingId), 1))
            : _createCommentVNode("", true),
          (_ctx.order.houseBillOfLading && _ctx.order.houseBillOfLading != '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, " HBL# " + _toDisplayString(_ctx.order.houseBillOfLading), 1))
            : (_ctx.order.bookingNumber)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " BKG # " + _toDisplayString(_ctx.order.bookingNumber), 1))
              : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.order.containers.length) + " " + _toDisplayString(_ctx.order.isExport ? 'Export(s)' : 'Import(s)'), 1),
          (_ctx.order.isDropHook)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Drop and Hook "))
            : (_ctx.isRailPickUp)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Rail Pick-Up "))
              : (_ctx.isRailDelivery)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Rail Delivery "))
                : (_ctx.isDomestic)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Load(s) "))
                  : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, "Created on: " + _toDisplayString(_ctx.order.createdAt), 1)
    ])
  ]))
}